// Settings look (showcase, 13 Oct design log): one section title for every settings tab and dialog.
// Contract card-title step 16/24/600 in primary ink: sentence case, never blue (blue is for what can
// be clicked) and never an all-caps tracked label. Replaces the per-site `frameV2Swap('text-sm
// font-bold tracking-wide uppercase text-brand-depth', 'text-text-primary')` headings.
export const SETTINGS_SECTION_TITLE = 'text-size-base font-semibold text-text-primary';
